import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from 'react-router-dom'
import { useTable, usePagination, useSortBy, useRowSelect } from "react-table";
import { Accordion, useAccordionToggle } from "react-bootstrap"
import { parse } from 'query-string'
import moment from "moment";
import _ from "lodash";
import L_PatientList from "../../LoadingEffectComponent/L_PatientList";
import TableFooter from "../../../Pages/Admin/TableFooter";
import TextInputWithIcon from "../../TextInputWithIcon";
import PgCheckbox from "../../PgCheckbox";
import FilterIcon from "../../../assets/filterIcon.png";

function PractitionerReportTable({ practitioner, error, updatePractitionerTable, totalData, loading }) {
    const [showFilterOption, setShowFilterOption] = useState(false);
  const navigate = useNavigate();
    const [controlledPageCount, setControlledPageCount] = useState(1);
    const [sPageIndex, setSPageIndex] = useState(0);
    const [searchText, setSearchText] = useState("");
    const [recentURL, setRecentURL] = useState("")
    const [filter, setFilter] = useState([])

    const [sortName, setsortName] = useState("");

    const continueSort = (url) => {
        if (sortName) {
            updatePractitionerTable(`${url}&sort_key=email&sort_value=${sortName}`);
        } else {
            updatePractitionerTable(url)
        }
    }
    useEffect(() => {
        gotoPage(0);
    }, [searchText])

    const manualSort = (e) => {
        const field = e.target.innerText.split(' ')[0]?.toLowerCase();
        console.log(field);
        if (field === "name") {
            setsortName(sortName === "" ? 'DESC' : sortName === "DESC" ? "ASC" : "DESC")
            updatePractitionerTable(`${recentURL}&sort_key=last_name&sort_value=${sortName === "" ? 'DESC' : sortName === "DESC" ? "ASC" : "DESC"}`)
        }
    }

    const column = [
        { Header: `Requested By  ${sortName === "DESC" ? ' ↓' : ' ↑'}`, accessor: "requested_by" },
        {
            Header: "Email", accessor: "email", Cell: (value) => {
                return <div>{value.value}</div>
            }
        },
        {
            Header: "Status", accessor: "status", Cell: (raw_data) => {
                const data = raw_data.value;
                return <div>{_.startCase(data)}</div>
            }
        },
        {
            Header: "Requested Date", accessor: "created_at", Cell: (value) => {
                return <div>{moment(value.value).format('L')}</div>
            }
        },
        {
            Header: "Action", accessor: "url", Cell: (value) => {
                return <div>{value?.row?.original?.status === "completed" && (<a download href={value?.value?.url}>Download</a>) }</div>
            }
        },
    ];

    const columns = useMemo(() => column, [practitioner]);
    const data = useMemo(() => practitioner, [practitioner]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        canNextPage,
        previousPage,
        canPreviousPage,
        pageOptions,
        pageCount,
        gotoPage,
        setPageSize,
        state: { pageIndex, pageSize },
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageIndex: sPageIndex,
                pageSize: 100
            },
            manualPagination: true,
            pageCount: controlledPageCount,
            autoResetSortBy: false,
            // autoResetPage: true,
            autoResetPage: false,
            disableSortRemove: true,
            defaultCanSort: true,
        },
        useSortBy,
        usePagination,
        useRowSelect
    );

    useEffect(() => {
        const url = parse(window.location.search);
        if (url.p_id) {
            setSearchText(url.p_id)
        }
    }, []);

    useEffect(() => {
        setControlledPageCount(Math.ceil(totalData / pageSize));
    });
    useEffect(() => {
        let url = `per_page=${pageSize}&page=${pageIndex + 1}`;
        if (searchText.trim().length > 1) url += `&search=${searchText}`;
        setRecentURL(url);
        const delayDebounceFn = setTimeout(() => {
            continueSort(url);
        }, 1000)
        return () => clearTimeout(delayDebounceFn)
        // updatePractitionerTable(url);
    }, [pageSize, pageIndex, searchText]);

    return (
        <div>
            <div className="my-5">
                <div className="text-center">
                    <div className="row justify-content-center">
                        <div className="col-6">
                            <TextInputWithIcon
                                label="Patient Name"
                                required={false}
                                value={searchText}
                                inputHandler={(e) => setSearchText(e.target.value)}
                                // fetchTypedPatient={fetchTypedPatient}
                                placeholder="Search Practitioner"
                                type="search"
                                id="search-patient__patientlist"
                                Icon={
                                    <i
                                        className="fa fa-search text-secondary"
                                        aria-hidden="true"
                                    ></i>
                                }
                            />
                        </div>
                    </div>
                </div>

            </div>
            {/* Table  */}
            {loading
                ? <L_PatientList />
                : <div>
                    <table {...getTableProps()} className="pg-table  my-2">
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps(column.getSortByToggleProps())} onClick={manualSort}>
                                            {column.render("Header")}
                                            <span className="fs-4">
                                                {column.isSorted ? (column.isSortedDesc ? "↓" : "↑") : ""}{" "}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        {error && (
                            <tbody>
                                <tr>
                                    <td colSpan="5">
                                        <div className="w-100 text-center">
                                            Unable to fetch practitioner list
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                        {practitioner.length < 1 && !error && (
                            <tbody>
                                <tr>
                                    <td colSpan="5">
                                        <div className="w-100 text-center">No Practitioner Found</div>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                        {practitioner.length > 0 && !error && (
                            <tbody {...getTableBodyProps()}>
                                {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()}>
                                            {row.cells.map((cell) => {
                                                return (
                                                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        )}
                    </table>
                    <TableFooter
                        pageSize={pageSize}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        previousPage={previousPage}
                        setPageSize={setPageSize}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                    />
                </div>}
        </div>
    )
}

export default PractitionerReportTable
